import type { TMessages } from '@/types/TMessages'

export const messages = { newsHeader: 'Новости', allNews: 'Все новости' } satisfies TMessages
